import React, { useState, useEffect } from 'react';
import {
    TextField,
    Checkboxes,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Autocomplete
} from 'mui-rff';
import {
    makeStyles,
    withStyles,
    Typography,
    Slide as MUISlide,
    Dialog,
    IconButton,
    DialogContent,
    DialogActions,
    Button,
    DialogTitle,
    DialogContentText,
    Card,
    CardContent,
    FormHelperText,
    Collapse,
    Menu,
    MenuList,
    ClickAwayListener,
    Grow,
    Popper
} from "@material-ui/core";
import useStyles from './editProfileDialogCss';
import CloseIcon from '@material-ui/icons/Close';
import { Form, Field } from 'react-final-form';
import { connect } from "react-redux";
import { accountDetails } from "../../../store/actions/authActionCreators";
import { GetValuesFromGst } from "../../../store/actions/userActionCreators";
import * as logger from '../../../logger';
import { getAllLocationsForProfile,getAllLocationsForStates } from '../../../store/actions/homeActionCreator';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import ReceiptIcon from '@material-ui/icons/Receipt';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import CircularProgress from '@material-ui/core/CircularProgress';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import AddLocationIcon from '@material-ui/icons/AddLocation';
import Slide from "@material-ui/core/Slide";
import { trackDwebEvent } from '../../analytics';
import { OnChange } from 'react-final-form-listeners'
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';

function sleep(delay = 0) {
    return new Promise((resolve) => {
        setTimeout(resolve, delay);
    });
}

const filter = createFilterOptions({
    limit: 30
});

const EditProfileDialog = ({ onOpen, user, onClose, onConfirm, dispatchEditUser,dispatchGetAllLocationsForStates, dispatchGetAllLocationsForProfile, userInfoProfile, dispatchGetDetailsFromGst }) => {

    let submit;
    const [dialogOpen, setDialogOpen] = useState(onOpen);
    const [open, setOpen] = React.useState(false);
    const [cityName, setCityName] = useState("");
    const [stateName, setStateName] = useState("");
    const [openState, setOpenState] = useState(false);
    const [detailsGst, setDetailsGst] = useState({});

    const classes = useStyles();

    useEffect(() => {
        if (user && user.cityName && user.cityName.length > 0) {
            return;
        }
        dispatchGetAllLocationsForProfile(
            () => {
                logger.log("Edit Profile Dialog Dweb", "------> Get all locations Success ");
            }, () => {
                logger.log("Edit Profile Dialog Dweb", "------> Get all locations Failure");
            });
            dispatchGetAllLocationsForStates(
                () => {
                    logger.log("Edit Profile Dialog Dweb", "------> Get all locations Success ");
                }, () => {
                    logger.log("Edit Profile Dialog Dweb", "------> Get all locations Failure");
                });
    }, [dialogOpen]);

    let initialValues = {
        name: userInfoProfile && userInfoProfile.name ? userInfoProfile.name : "",
        gstNumber: userInfoProfile && userInfoProfile.gst ? userInfoProfile.gst : "",
        panNumber: detailsGst && detailsGst.pan_number ? detailsGst.pan_number : (userInfoProfile && userInfoProfile.panNumber ? userInfoProfile.panNumber : ""),
        companyName: detailsGst && detailsGst.name ? detailsGst.name : (userInfoProfile && userInfoProfile.companyName ? userInfoProfile.companyName : ""),
        addressLine1: detailsGst && detailsGst.address_line_1 ? detailsGst.address_line_1 : (userInfoProfile && userInfoProfile.addressLine1 ? userInfoProfile.addressLine1 : ""),
        addressLine2: detailsGst && detailsGst.address_line_2 ? detailsGst.address_line_2 : (userInfoProfile && userInfoProfile.addressLine2 ? userInfoProfile.addressLine2 : ""),
        pinCode: detailsGst && detailsGst.pincode ? detailsGst.pincode : (userInfoProfile && userInfoProfile.pincode ? userInfoProfile.pincode : ""),
        cityName: userInfoProfile && userInfoProfile.city_name ? userInfoProfile.city_name : "",
        stateName: detailsGst && detailsGst.state ? detailsGst.state : (userInfoProfile && userInfoProfile.state_name ? userInfoProfile.state_name : "")
    }

    useEffect(() => {
        if (user.detailsFromGst) {
            setDetailsGst(user.detailsFromGst);
        }
    }, [dialogOpen, user.detailsFromGst]);

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }

    const onSubmit = async values => {

        const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
        await sleep(300);

        var data = {
            city_name: cityName ? cityName : "",
            state: stateName ? stateName : "",
            gst: values && values.gstNumber ? (values.gstNumber).toUpperCase() : "",
            name: values.name ? values.name : "",
            panNumber: values && values.panNumber ? (values.panNumber).toUpperCase() : "",
            companyName: values.companyName ? values.companyName : "",
            addressLine1: values.addressLine1 ? values.addressLine1 : "",
            addressLine2: values.addressLine2 ? values.addressLine2 : "",
            pincode: values.pinCode ? values.pinCode : ""
        }

        dispatchEditUser(data,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    setDialogOpen(false);
                    onConfirm();
                    logger.log("Edit Profile Component Dweb", "Edit user successfull");
                    trackDwebEvent("Dweb Profile Update", {});
                }
            },
            () => {
                logger.log("Edit Profile Component Dweb", "Edit user failed");
            }
        );

    }

    const validate = values => {

        let config = JSON.parse(localStorage.getItem("USER_APP_CONFIG"));

        let gstValidation = config && config.gstRegex ? new RegExp(config.gstRegex) : "";
        let panValidation = config && config.panRegex ? new RegExp(config.panRegex) : "";
        let pinCodeValidation = config && config.pincodeRegex ? new RegExp(config.pincodeRegex) : "";

        let gstUpperCase = values.gstNumber ? (values.gstNumber).toUpperCase() : "";
        let panUpperCase = values.panNumber ? (values.panNumber).toUpperCase() : "";

        const errors = {};

        if (!values.name) {
            errors.name = "Please enter name"
        }
        if (!values.companyName) {
            errors.companyName = "Please enter the company name"
        }
        if (values.gstNumber && (!gstValidation.test(gstUpperCase))) {
            errors.gstNumber = "Invalid GST Number"
        }
        if (values.panNumber && (!panValidation.test(panUpperCase))) {
            errors.panNumber = "Invalid PAN Number."
        }
        if (values.pinCode && (!pinCodeValidation.test(values.pinCode))) {
            errors.pinCode = "Pin code must be of length 6 and must contain only Numbers."
        }

        return errors;
    }

    const selectCityName = [
        {
            size: 6,
            field: (
                <Autocomplete
                    classes={{
                        listbox: classes.listBoxAutoCompelete,
                        option: classes.listBoxOption
                    }
                    }
                    id="select-city-name-list"
                    // label="Party"
                    name="cityName"
                    size="small"
                    placeholder="City"
                    open={open}
                    onOpen={() => {
                        setOpen(true);
                    }}
                    onClose={() => {
                        setOpen(false);
                    }}
                    // value={cityName}
                    onChange={(event, newValue) => {

                        let newTypeValue = newValue ? newValue.toString() : "";

                        if (typeof newTypeValue === 'string') {

                            // timeout to avoid instant validation of the dialog's form.
                            setTimeout(() => {
                                // toggleAddReasonOpen(true);
                                setCityName(newValue);
                            });
                        } else if (newValue) {
                            // toggleAddReasonOpen(true);
                            setCityName(newValue);
                        } else if (newValue === '') {
                            // toggleAddReasonOpen(true);
                            setCityName(newValue);
                        } else {
                            setCityName(newValue);
                        }
                    }}
                    getOptionSelected={(option, value) => option === value}
                    autoHighlight
                    freeSolo
                    options={user && user.cityName ? user.cityName : []}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    getOptionValue={option => option.replace(/\'/g, "")}
                    getOptionLabel={(option) => {
                        // e.g value selected with enter, right from the input
                        let value = option.replace(/\'/g, "");
                        if (typeof option === 'string') {
                            setCityName(value);
                            return value;
                        }
                        if (option) {
                            setCityName(value);
                            return value;
                        }
                        setCityName(value);
                        return value;
                    }}
                    disableCloseOnSelect={false}
                    filterOptions={(options, params) => {
                        const filtered = filter(options, params);

                        if (params.inputValue !== '' && filtered && filtered.length == 0) {
                            filtered.unshift(
                                `'${params.inputValue}'`,
                            );
                        }


                        return filtered;

                    }}
                    filterSelectedOptions
                    renderOption={(option, params) => {
                        let matchesName = match(option, params.inputValue);
                        let partsName = parse(option, matchesName);
                        if (params.inputValue !== '' && option.toString().includes("\'")) {
                            return (
                                <>
                                    <div className={classes.divV1}>
                                        <div className={classes.divV2}>
                                            <div>
                                                <AddLocationIcon className={classes.locationOnIcon} />
                                            </div>
                                            <div className={classes.divV3}>
                                                <div className={classes.divV4} >{option}</div>
                                                <div className={classes.divV5}>Tap to add new City</div>
                                            </div>
                                        </div>
                                        <ChevronRightIcon className={classes.cherveRightIcon} />
                                    </div>
                                </>
                            );
                        } else {
                            return (
                                <div style={{ display: 'flex', width: '100%', paddingTop: 5, paddingBottom: 5 }}>
                                    <LocationOnIcon style={{ color: 'lightgray' }} />
                                    <div style={{ borderBottom: '1px solid #D8D8D8', width: '100%', paddingBottom: 10, paddingLeft: 5 }}>
                                        {partsName.map((part, index) => {
                                            return (<span key={index} style={{ fontWeight: part.highlight ? 700 : 300, color: part.highlight ? '#00875a' : '#0b1323' }}>
                                                {part.text}
                                            </span>
                                            )
                                        })}
                                    </div>
                                </div>


                            );
                        }
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            // label="Enter Reason"
                            placeholder="City"
                            variant="outlined"
                            name="cityName"
                            margin='normal'
                            style={{ margin: 0, marginTop: 6 }}
                        />
                    )}
                    multiple={false}
                />
            ),
        }
    ]

    const selectStateName = [
        {
            size: 6,
            field: (
                <Autocomplete
                    classes={{
                        listbox: classes.listBoxAutoCompelete,
                        option: classes.listBoxOption
                    }
                    }
                    id="select-state-name-list"
                    // label="Party"
                    name="stateName"
                    size="small"
                    placeholder="State"
                    forcePopupIcon={false}
                    open={openState}
                    onOpen={() => {
                        setOpenState(true);
                    }}
                    onClose={() => {
                        setOpenState(false);
                    }}
                    // value={stateName}
                    onChange={(event, newValue) => {

                        let newTypeValue = newValue ? newValue.toString() : "";

                        if (typeof newTypeValue === 'string') {

                            // timeout to avoid instant validation of the dialog's form.
                            setTimeout(() => {
                                // toggleAddReasonOpen(true);
                                setStateName(newValue);
                            });
                        } else if (newValue) {
                            // toggleAddReasonOpen(true);
                            setStateName(newValue);
                        } else if (newValue === '') {
                            // toggleAddReasonOpen(true);
                            setStateName(newValue);
                        } else {
                            setStateName(newValue);
                        }
                    }}
                    getOptionSelected={(option, value) => option === value}
                    autoHighlight
                    options={user && user.stateName ? user.stateName : []}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    getOptionValue={option => option.replace(/\'/g, "")}
                    getOptionLabel={(option) => {
                        // e.g value selected with enter, right from the input
                        let value = option.replace(/\'/g, "");
                        if (typeof option === 'string') {
                            setStateName(value)
                            return value;
                        }
                        if (option) {
                            setStateName(value)
                            return value;
                        }
                        setStateName(value)
                        return value;
                    }}
                    disableCloseOnSelect={false}
                    filterOptions={(options, params) => {
                        const filtered = filter(options, params);

                        // if (params.inputValue !== '') {
                        //     filtered.unshift(
                        //         `'${params.inputValue}'`,
                        //     );
                        // }

                        return filtered;

                    }}
                    renderOption={(option, params) => {
                        let matchesName = match(option, params.inputValue);
                        let partsName = parse(option, matchesName);
                        return (
                            <div style={{ display: 'flex', width: '100%', paddingTop: 5, paddingBottom: 5 }}>
                                <LocationOnIcon style={{ color: 'lightgray' }} />
                                <div style={{ borderBottom: '1px solid #D8D8D8', width: '100%', paddingBottom: 10, paddingLeft: 5 }}>
                                    {partsName.map((part, index) => {
                                        return (<span key={index} style={{ fontWeight: part.highlight ? 700 : 300, color: part.highlight ? '#00875a' : '#0b1323' }}>
                                            {part.text}
                                        </span>
                                        )
                                    })}
                                </div>
                            </div>
                        );

                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            // label="Enter Reason"
                            placeholder="State"
                            variant="outlined"
                            name="stateName"
                            margin='normal'
                            style={{ margin: 0, marginTop: 6 }}
                        />
                    )}
                    multiple={false}
                />
            ),
        }
    ]


    const handleGstChange = (value) => {
        if (value.length == 15) {
            dispatchGetDetailsFromGst(value,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log("Edit Profile Dialog Dweb", "Get Details from GST Successfull");
                    }
                },
                () => {
                    logger.log("Edit Profile Dialog Dweb", "Get Details from GST Failed");
                }
            );
        }
    }

    return (
        <>
            <Dialog fullWidth={true} fullScreen classes={{ paper: classes.modalWidth, scrollPaper: classes.paper1 }} TransitionComponent={Slide} TransitionProps={{ direction: 'left' }}
                onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-driver-dialog-title" open={dialogOpen}>
                <DialogTitle onClose={handleClose} className={classes.dialogTitleV1}>
                    <div className={classes.divFlex}>
                        Personal Information
                    </div>
                </DialogTitle>
                <DialogContent className={classes.dialogContent}>
                    <Form keepDirtyOnReinitialize
                        onSubmit={onSubmit}
                        initialValues={initialValues}
                        validate={validate}
                        id="myForm"
                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                            submit = handleSubmit
                            return (
                                <form
                                    onSubmit={(event) => {
                                        const promise = handleSubmit(event);
                                        // promise && promise.then(() => {
                                        //     form.reset();
                                        // })
                                        return promise;
                                    }} id="myForm" noValidate>

                                    <div className={classes.divAmount}>Name</div>
                                    <TextField
                                        // label="Amount"
                                        placeholder="Name"
                                        name="name"
                                        variant="outlined"
                                        size="small"
                                        className={classes.marginV1}
                                    />

                                    <div className={classes.divAmount} >GST Number</div>
                                    <TextField
                                        // label="Amount"
                                        placeholder="GST Number"
                                        name="gstNumber"
                                        variant="outlined"
                                        size="small"
                                        className={classes.gstNumber}
                                    />
                                    <OnChange name="gstNumber">
                                        {(value, previous) => {
                                            handleGstChange(value);
                                        }}
                                    </OnChange>

                                    <div className={classes.divAmount} >PAN</div>
                                    <TextField
                                        // label="Amount"
                                        placeholder="PAN Number"
                                        name="panNumber"
                                        variant="outlined"
                                        size="small"
                                        className={classes.gstNumber}
                                    />

                                    <div className={classes.divAmount} >Company Name</div>
                                    <TextField
                                        // label="Amount"
                                        placeholder="Company Name"
                                        name="companyName"
                                        variant="outlined"
                                        size="small"
                                        className={classes.marginV1}
                                    />


                                    <div className={classes.address}>Address Information</div>

                                    <div className={classes.divAmount} >Address Line 1</div>
                                    <TextField
                                        // label="Amount"
                                        placeholder="Address Line 1"
                                        name="addressLine1"
                                        variant="outlined"
                                        size="small"
                                        className={classes.marginV1}
                                    />

                                    <div className={classes.divAmount} >Address Line 2</div>
                                    <TextField
                                        // label="Amount"
                                        placeholder="Address Line 2"
                                        name="addressLine2"
                                        variant="outlined"
                                        size="small"
                                        className={classes.marginV1}
                                    />

                                    <div className={classes.divAmount} >City</div>
                                    {user && user.cityName && user.cityName.length > 0 && selectCityName.map((item, idx) => (
                                        item.field
                                    ))}

                                    <div className={classes.divAmount} >State</div>
                                    {user && user.stateName && user.stateName.length > 0 && selectStateName.map((item, idx) => (
                                        item.field
                                    ))}

                                    <div className={classes.divAmount} >Pincode</div>
                                    <TextField
                                        // label="Amount"
                                        placeholder="Pin Code"
                                        name="pinCode"
                                        variant="outlined"
                                        size="small"
                                        className={classes.marginV2}
                                    />
                                </form>
                            )
                        }}
                    />

                </DialogContent>

                <DialogActions className={classes.da1}>
                    <Button variant="contained" className={classes.cancelButton} onClick={() => handleClose()} >
                        Close
                    </Button>
                    <Button className={classes.confirmV1} type="submit" variant="contained"
                        onClick={event => {
                            submit(event)
                        }}
                    >
                        Save changes
                    </Button>
                </DialogActions>
            </Dialog>

        </>
    )
}

const mapStateToProps = (state) => ({ user: state.user, vehicle: state.vehicle, userInfoProfile: state.user.userInfoProfile });
const mapDispatchToProps = (dispatch) => ({
    dispatchEditUser: (data, onSuccess, onFailure) => { dispatch(accountDetails(data, onSuccess, onFailure, false)) },
    dispatchGetAllLocationsForProfile: (onSuccess, onFailure) => { dispatch(getAllLocationsForProfile(onSuccess, onFailure)) },
    dispatchGetAllLocationsForStates: (onSuccess, onFailure) => { dispatch(getAllLocationsForStates(onSuccess, onFailure)) },
    dispatchGetDetailsFromGst: (gstNumber, onSuccess, onFailure) => { dispatch(GetValuesFromGst(gstNumber, onSuccess, onFailure)) }
});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditProfileDialog);